import { CircleIcon, type ColorPalette, Flex, Text, type Theme } from '@shared/components';

type PaletteColor = keyof Theme['palette'][ColorPalette];
type GreyColor = keyof Theme['palette']['grey'];

export type CircleIndicatorLabelProps =
  | {
      label: string;
      color: `${ColorPalette}`;
      tone?: PaletteColor;
    }
  | {
      label: string;
      color: 'grey';
      tone?: GreyColor;
    };

function getColor(color: `${ColorPalette}` | 'grey', tone: PaletteColor | GreyColor, theme: Theme) {
  if (color === 'grey') {
    return theme.palette.grey[tone as GreyColor];
  } else {
    return theme.palette[color][tone as PaletteColor];
  }
}

export default function CircleIndicatorLabel(props: Readonly<CircleIndicatorLabelProps>) {
  const { color, label, tone = 'main' } = props;

  return (
    <Flex sx={{ alignItems: 'center' }}>
      <CircleIcon
        sx={(theme) => ({
          width: '10px',
          height: '10px',
          mr: theme.spacing(2),
          color: getColor(color, tone, theme),
        })}
      />
      <Text>{label}</Text>
    </Flex>
  );
}
